import * as React from 'react';

import EnrollmentWorkflow from './EnrollmentWorkflow';
import { Button } from '../../components/buttons';

interface Props {
	user: UserDetails;
	customerPolicy: CustomerPolicy;
	actions?: any;
	history?: any;
	match?: any;
}
class EnrollmentPage extends React.Component<Props, any> {
	setDevQuestionnaire = () => {
		this.props.actions.setDevQuestionnaire();
		this.props.history.push(`/quote/A/enrollment/review`);
	}

	componentDidMount() {
		this.redirectIfInvalidData();
	}

	componentWillReceiveProps(nextProps: Props) {
		if (
			nextProps.match.params.page !== this.props.match.params.page ||
			nextProps.match.params.enrollmentPage !== this.props.match.params.enrollmentPage
		) {
			this.redirectIfInvalidData();
		}
	}

	redirectIfInvalidData = () => {
		if (this.props.customerPolicy.id == null || this.props.user.id == null) {
			this.props.history.push(`/quote/${this.props.match.params.workflow}/about-you`);
		}
	}

	render() {
		return (
			<div>
				<EnrollmentWorkflow {...this.props} />
				{process.env.NODE_ENV !== 'production' && (
					<div className="text-center">
						<Button className="btn-outline-secondary mt-3" onClick={this.setDevQuestionnaire}>
							Auto-fill questionnaire (dev)
						</Button>
					</div>
				)}
			</div>
		);
	}
}

export default EnrollmentPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/EnrollmentPage.tsx